export const AuthInitialState = {
  accessToken: null,
  login: null,
  role: "",
  id: "",
  email: "",
  name: "",
  profileUrl: "",
  bio: "",
  number: "",
  idToken: "",
};
